import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id E2791217-9CAB-41CA-9899-9BD0964B4DF9
 * name rocket-launch
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rocket-launch.svg
 * tags
 * - Science 
 * - Transportation + Flying 
 */
export const RocketLaunchIcon = createSvgIcon(<><path d="M13.16 22.19L11.5 18.35C13.1 17.77 14.57 17 15.93 16.08L13.15 22.19M5.65 12.5L1.81 10.85L7.92 8.07C7 9.43 6.23 10.9 5.65 12.5M21.66 2.35C21.66 2.35 23.78 7.31 18.11 13C15.91 15.17 13.53 16.5 11.38 17.34C10.64 17.62 9.81 17.44 9.26 16.88L7.13 14.75C6.57 14.19 6.39 13.37 6.66 12.62C7.5 10.5 8.83 8.09 11 5.89C16.69 .216 21.66 2.35 21.66 2.35M6.25 22H4.84L8.93 17.9C9.23 18.11 9.56 18.26 9.9 18.35L6.25 22M2 22V20.59L6.77 15.81L8.2 17.23L3.41 22H2M2 19.16V17.75L5.65 14.1C5.74 14.45 5.89 14.78 6.1 15.07L2 19.16M16 6C14.9 6 14 6.9 14 8C14 9.11 14.9 10 16 10C17.11 10 18 9.11 18 8C18 6.9 17.11 6 16 6Z" /></>, 'RocketLaunchIcon');
export default RocketLaunchIcon